import React from 'react'

const LOCALES = {
  remark: {
    de: 'Hinweis',
    fr: 'Remarque'
  },
  warning_less_than_fifty_zh: {
    de:
      'Im Kanton Zürich wurden bisher weniger als die Hälfte der Gemeinden ausgezählt. Schauen Sie doch in ein paar Stunden noch einmal vorbei, falls es für Ihre Gemeinde noch keine Ergebnisse gibt.',
    fr:
      'Dans le canton de Zurich, moins de la moitié des communes ont été comptées jusqu’à présent. Veuillez revenir dans quelques heures s’il n’y a pas encore de résultats pour votre municipalité.'
  },
  warning_more_than_fifty_zh: {
    de:
      'Im Kanton Zürich wurden bereits mehr als 50 Prozent der Gemeinden ausgezählt. Falls Ihre Gemeinde trotzdem noch nicht darunter ist, schauen Sie doch in ein paar Minuten wieder vorbei.',
    fr:
      'Dans le canton de Zurich, plus de la moitié des communes ont déjà été comptées. Si votre municipalité n’est toujours pas incluse, veuillez revenir dans quelques minutes.'
  },
  warning_less_than_fifty_be: {
    de:
      'Im Kanton Bern wurden bisher weniger als die Hälfte der Gemeinden ausgezählt. Schauen Sie doch in ein paar Stunden noch einmal vorbei, falls es für Ihre Gemeinde noch keine Ergebnisse gibt.',
    fr:
      'Dans le canton de Berne, moins de la moitié des communes ont été comptées jusqu’à présent. Veuillez revenir dans quelques heures s’il n’y a pas encore de résultats pour votre municipalité.'
  },
  warning_more_than_fifty_be: {
    de:
      'Im Kanton Bern wurden bereits mehr als 50 Prozent der Gemeinden ausgezählt. Falls Ihre Gemeinde trotzdem noch nicht darunter ist, schauen Sie doch in ein paar Minuten wieder vorbei.',
    fr:
      'Dans le canton de Berne, plus de la moitié des communes ont déjà été comptées. Si votre municipalité n’est toujours pas incluse, veuillez revenir dans quelques minutes.'
  },
  warning_less_than_fifty_vd: {
    de:
      'Im Kanton Waadt wurden bisher weniger als die Hälfte der Gemeinden ausgezählt. Schauen Sie doch in ein paar Stunden noch einmal vorbei, falls es für Ihre Gemeinde noch keine Ergebnisse gibt.',
    fr:
      'Dans le canton de Vaud, moins de la moitié des communes ont été comptées jusqu’à présent. Veuillez revenir dans quelques heures s’il n’y a pas encore de résultats pour votre municipalité.'
  },
  warning_more_than_fifty_vd: {
    de:
      'Im Kanton Waadt wurden bereits mehr als 50 Prozent der Gemeinden ausgezählt. Falls Ihre Gemeinde trotzdem noch nicht darunter ist, schauen Sie doch in ein paar Minuten wieder vorbei.',
    fr:
      'Dans le canton de Vaud, plus de la moitié des communes ont déjà été comptées. Si votre municipalité n’est toujours pas incluse, veuillez revenir dans quelques minutes.'
  },
  warning_less_than_fifty_ge: {
    de:
      'Im Kanton Genf wurden bisher weniger als die Hälfte der Gemeinden ausgezählt. Schauen Sie doch in ein paar Stunden noch einmal vorbei, falls es für Ihre Gemeinde noch keine Ergebnisse gibt.',
    fr:
      'Dans le canton de Genève, moins de la moitié des communes ont été comptées jusqu’à présent. Veuillez revenir dans quelques heures s’il n’y a pas encore de résultats pour votre municipalité.'
  },
  warning_more_than_fifty_ge: {
    de:
      'Im Kanton Genf wurden bereits mehr als 50 Prozent der Gemeinden ausgezählt. Falls Ihre Gemeinde trotzdem noch nicht darunter ist, schauen Sie doch in ein paar Minuten wieder vorbei.',
    fr:
      'Dans le canton de Genève, plus de la moitié des communes ont déjà été comptées. Si votre municipalité n’est toujours pas incluse, veuillez revenir dans quelques minutes.'
  },
  warning_less_than_fifty_ba: {
    de:
      'In den Kantonen Basel-Stadt und Basel-Landschaft wurden bisher weniger als die Hälfte der Gemeinden ausgezählt. Schauen Sie doch in ein paar Stunden noch einmal vorbei, falls es für Ihre Gemeinde noch keine Ergebnisse gibt.',
    fr:
      'Dans les cantons de Bâle-Ville et Bâle-Campagne, moins de la moitié des communes ont été comptées jusqu’à présent. Veuillez revenir dans quelques heures s’il n’y a pas encore de résultats pour votre municipalité.'
  },
  warning_more_than_fifty_ba: {
    de:
      'In den Kantonen Basel-Stadt und Basel-Landschaft wurden bereits mehr als 50 Prozent der Gemeinden ausgezählt. Falls Ihre Gemeinde trotzdem noch nicht darunter ist, schauen Sie doch in ein paar Minuten wieder vorbei.',
    fr:
      'Dans les cantons de Bâle-Ville et Bâle-Campagne, plus de la moitié des communes ont déjà été comptées. Si votre municipalité n’est toujours pas incluse, veuillez revenir dans quelques minutes.'
  }
}

export default LOCALES
